import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',    //pc端首页
      component: () => import('@/views/pcWeb/index.vue'),
    },
    {
      path: '/mindex', // 移动端首页
      name: 'MbIndex',
      component: () => import('@/views/mWeb/index.vue'),
    },
    {
      path: "/waterfall",
      name: "waterfall",
      component: () => import("@/views/pcWeb/waterfall.vue")
    },
    {
      path: '/portal/about/index',
      name: 'about',
      component: () => import('@/views/pcWeb/about.vue'),
    },
    {
      path: '/portal/about/mindex',
      name: 'mabout',
      component: () => import('@/views/mWeb/mAbout.vue'),
    },
    {
      path: '/portal/about/hezuo',
      name: 'hezuo',
      component: () => import('@/views/pcWeb/hezuo.vue'),
    },
    {
      path: '/portal/about/mhezuo',
      name: 'mhezuo',
      component: () => import('@/views/mWeb/mhezuo.vue'),
    },
    {
      path: '/portal/about/map',
      name: 'map',
      component: () => import('@/views/pcWeb/map.vue'),
    },
    {
      path: '/portal/about/mmap',
      name: 'mmap',
      component: () => import('@/views/mWeb/mMap.vue'),
    },
    {
      path: '/portal/about/huanjing',
      name: 'huanjing',
      component: () => import('@/views/pcWeb/huanjing.vue'),
    },
    {
      path: '/portal/about/mhuanjing',
      name: 'mhuanjing',
      component: () => import('@/views/mWeb/mhuanjing.vue'),
    },
    {
      path: '/portal/about/kecheng',
      name: 'kecheng',
      component: () => import('@/views/pcWeb/kecheng.vue'),
    },
    {
      path: '/portal/about/mkecheng',
      name: 'mkecheng',
      component: () => import('@/views/mWeb/mkecheng.vue'),
    },
    {
      path: '/portal/about/chengji',
      name: 'chengji',
      component: () => import('@/views/pcWeb/chengji.vue'),
    },
    {
      path: '/portal/about/mchengji',
      name: 'mchengji',
      component: () => import('@/views/mWeb/mchengji.vue'),
    },
    {
      path: '/portal/article/video',
      name: 'video',
      component: () => import('@/views/pcWeb/video.vue'),
    },
    {
      path: '/portal/article/mvideo',
      name: 'mvideo',
      component: () => import('@/views/mWeb/mvideo.vue'),
    },
    {
      path: '/portal/article/player/',
      name: 'player',
      component: () => import('@/views/pcWeb/child/video/player.vue'),
      children: [
        {
          path: 'id/131',
          name: 'player131',
          component: () => import('@/views/pcWeb/child/video/player131.vue'),
        },
        {
          path: 'id/130',
          name: 'player130',
          component: () => import('@/views/pcWeb/child/video/player130.vue'),
        },
        {
          path: 'id/129',
          name: 'player129',
          component: () => import('@/views/pcWeb/child/video/player129.vue'),
        },
        {
          path: 'id/128',
          name: 'player128',
          component: () => import('@/views/pcWeb/child/video/player128.vue'),
        },
        {
          path: 'id/127',
          name: 'player127',
          component: () => import('@/views/pcWeb/child/video/player127.vue'),
        },
        {
          path: 'id/126',
          name: 'player126',
          component: () => import('@/views/pcWeb/child/video/player126.vue'),
        },
        {
          path: 'id/125',
          name: 'player125',
          component: () => import('@/views/pcWeb/child/video/player125.vue'),
        },
        {
          path: 'id/124',
          name: 'player124',
          component: () => import('@/views/pcWeb/child/video/player124.vue'),
        },
        {
          path: 'id/123',
          name: 'player123',
          component: () => import('@/views/pcWeb/child/video/player123.vue'),
        },
      ]
    },  
    {
      path: '/portal/works/index',
      name: 'work',
      component: () => import('@/views/pcWeb/work.vue'),
    },
    {
      path: '/portal/works/mindex',
      name: 'mwork',
      component: () => import('@/views/mWeb/mwork.vue'),
    },
    {
      path: '/portal/works/lists/id/:id',
      name: 'workList',
      component: () => import('@/views/pcWeb/workList.vue'),
    },
    {
      path: '/portal/teacher/index',
      name: 'teacher',
      component: () => import('@/views/pcWeb/teacher.vue'),
    },
    {
      path: '/portal/teacher/mindex',
      name: 'mteacher',
      component: () => import('@/views/mWeb/mteacher.vue'),
    },
    {
      path: '/portal/about/page',
      name: 'page',
      component: () => import('@/views/pcWeb/page.vue'),
    }, 
    {
      path: '/portal/about/mpage',
      name: 'mpage',
      component: () => import('@/views/mWeb/mpage.vue'),
    }, 
    {
      path: '/portal/article/lists/',
      name: 'lists',
      component: () => import('@/views/pcWeb/lists.vue'),
      children: [
        {
          path: 'id/13',
          name: 'lists13',
          component: () => import('@/views/pcWeb/child/lists/list13.vue'),
        },
        {
          path: 'id/13/page/2',
          name: 'lists132',
          component: () => import('@/views/pcWeb/child/lists/list132.vue'),
        },
        {
          path: 'id/13/page/3',
          name: 'lists133',
          component: () => import('@/views/pcWeb/child/lists/list133.vue'),
        },
      ]
    },  
    {
      path: '/portal/article/details/',
      name: 'details',
      component: () => import('@/views/pcWeb/details.vue'),
      children: [
        {
          path: '/portal/article',
          name: 'article',
          component: () => import('@/views/pcWeb/article.vue'),
        },
        {
          path: '/portal/article/page/2',
          name: 'article',
          component: () => import('@/views/pcWeb/article2.vue'),
        },
        {
          path: 'id/173',
          name: 'page173',
          component: () => import('@/views/pcWeb/child/article/page173.vue'),
        },
        {
          path: 'id/71',
          name: 'page71',
          component: () => import('@/views/pcWeb/child/article/page71.vue'),
        },
        {
          path: 'id/70',
          name: 'page70',
          component: () => import('@/views/pcWeb/child/article/page70.vue'),
        },
        {
          path: 'id/69',
          name: 'page69',
          component: () => import('@/views/pcWeb/child/article/page69.vue'),
        },
        {
          path: 'id/68',
          name: 'page68',
          component: () => import('@/views/pcWeb/child/article/page68.vue'),
        },
        {
          path: 'id/67',
          name: 'page67',
          component: () => import('@/views/pcWeb/child/article/page67.vue'),
        },
        {
          path: 'id/66',
          name: 'page66',
          component: () => import('@/views/pcWeb/child/article/page66.vue'),
        },
      ]
    },

    {
      path: '/portal/teacher/',
      name: 'teachtop',
      component: () => import('@/views/pcWeb/child/teacher/teachtop.vue'),
      children: [
        {
          path: 'details/id/72',
          name: 'detail72',
          component: () => import('@/views/pcWeb/child/teacher/detail72.vue'),
        },
        {
          path: 'details/id/73',
          name: 'detail73',
          component: () => import('@/views/pcWeb/child/teacher/detail73.vue'),
        },
        {
          path: 'details/id/74',
          name: 'detail74',
          component: () => import('@/views/pcWeb/child/teacher/detail74.vue'),
        },
        {
          path: 'details/id/75',
          name: 'detail75',
          component: () => import('@/views/pcWeb/child/teacher/detail75.vue'),
        },
        {
          path: 'details/id/76',
          name: 'detail76',
          component: () => import('@/views/pcWeb/child/teacher/detail76.vue'),
        },
        {
          path: 'details/id/77',
          name: 'detail77',
          component: () => import('@/views/pcWeb/child/teacher/detail77.vue'),
        },
        {
          path: 'details/id/78',
          name: 'detail78',
          component: () => import('@/views/pcWeb/child/teacher/detail78.vue'),
        },
        {
          path: 'details/id/79',
          name: 'detail79',
          component: () => import('@/views/pcWeb/child/teacher/detail79.vue'),
        },
        {
          path: 'details/id/80',
          name: 'detail80',
          component: () => import('@/views/pcWeb/child/teacher/detail80.vue'),
        },
        {
          path: 'details/id/81',
          name: 'detail81',
          component: () => import('@/views/pcWeb/child/teacher/detail81.vue'),
        },
        {
          path: 'details/id/82',
          name: 'detail82',
          component: () => import('@/views/pcWeb/child/teacher/detail82.vue'),
        },
      ]
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js